import {FC} from 'react'
import { Assessment } from '../../core/_models'

type Props = {
  assessments: Assessment
}

const AssessmentsIdCell: FC<Props> = ({assessments}) => {
  return (
    <>
      {
        <div className='d-flex align-items-center'>
        {/* begin:: Avatar */}
        <div className='d-flex flex-column'>
            {assessments.id}
        </div>
      </div>
      }
    </>
  )
}

export {AssessmentsIdCell}
